import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormControlLabel,
  Switch,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  useTheme,
  alpha,
  Snackbar,
  Alert,
  CircularProgress
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CheckCircle as CheckCircleIcon,
  Block as BlockIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import { axiosInstance, localAxiosDelete, localAxiosGet, localAxiosPut,localAxiosToken } from '../../../../Axios/axios';

const LeaveTypes = () => {
  const theme = useTheme();
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [currentLeaveType, setCurrentLeaveType] = useState({
    leave_type: '',
    description: '',
    max_days: 0,
    is_active: true
  });
  
 
  const organization_id = localStorage.getItem('organizationId');
  const accessToken = localStorage.getItem('accessToken');
  
  useEffect(() => {
    fetchLeaveTypes();
  }, []);
 
  const fetchLeaveTypes = async () => {
    setLoading(true);
    try {
      
      const response = await axiosInstance(localAxiosGet(`/organization/getAllLeaveTypes?organization_id=${organization_id}`, accessToken));
      
      if (response.data.status === 'SUCCESS' && response.data.message.leaveTypes) {
        setLeaveTypes(response.data.message.leaveTypes.map(leaveType => ({
          ...leaveType,
          color: getLeaveTypeColor(leaveType.leave_type)
        })));
      }
    } catch (error) {
      console.error('Error fetching leave types:', error);
      showSnackbar('Failed to load leave types', 'error');
    } finally {
      setLoading(false);
    }
  };
 
  const getLeaveTypeColor = (leaveTypeName) => {
  const colors = [
    '#2196F3', '#F44336', '#4CAF50', '#9C27B0', '#FF9800', 
    '#795548', '#673AB7', '#00BCD4', '#E91E63', '#607D8B'
  ];
  
  // Just use the length to pick a color - simple and consistent
  const index = leaveTypeName.length % colors.length;
  return colors[index];
};
 
  const showSnackbar = (message, severity = 'success') => {
  setSnackbar({
    open: true,
    message: typeof message === 'string' ? message : JSON.stringify(message),
    severity
  });
};
  
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  
  const handleOpenDialog = (leaveType = null) => {
    if (leaveType) {
      setCurrentLeaveType({
        id: leaveType.id,
        leave_type: leaveType.leave_type,
        description: leaveType.description,
        max_days: leaveType.max_days,
        is_active: leaveType.is_active
      });
      setEditMode(true);
    } else {
      setCurrentLeaveType({
        leave_type: '',
        description: '',
        max_days: 0,
        is_active: true
      });
      setEditMode(false);
    }
    setDialogOpen(true);
  };
 
  const handleOpenDeleteDialog = (leaveType) => {
    setCurrentLeaveType(leaveType);
    setDeleteDialogOpen(true);
  };
  
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
 
  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentLeaveType({
      ...currentLeaveType,
      [name]: value
    });
  };
  
  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setCurrentLeaveType({
      ...currentLeaveType,
      [name]: checked
    });
  };
 
  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    setCurrentLeaveType({
      ...currentLeaveType,
      [name]: parseFloat(value)
    });
  };
 
  const handleSaveLeaveType = async () => {
    try {
      if (editMode) {
        
        const payload = {
          leave_type: currentLeaveType.leave_type,
          description: currentLeaveType.description,
          max_days: currentLeaveType.max_days,
          is_active: currentLeaveType.is_active
        };
        
        const response = await axiosInstance(localAxiosPut(
          `/organization/updateLeaveType/${currentLeaveType.id}`, 
          payload, 
          accessToken
          
        ));
        
        if (response.data.status === 'SUCCESS') {
          showSnackbar('Leave type updated successfully');
          fetchLeaveTypes(); 
        }
      } else {
        
        const payload = {
          organization_id: parseInt(organization_id),
          leave_type: currentLeaveType.leave_type,
          description: currentLeaveType.description,
          max_days: currentLeaveType.max_days
        };
        
        const response = await axiosInstance(localAxiosToken(
          '/organization/createLeaveType', 
          payload, 
        ));
        
        if (response.data.status === 'SUCCESS') {
          showSnackbar('Leave type created successfully');
          fetchLeaveTypes(); 
        }
      }
      handleCloseDialog();
    } catch (error) {
      console.error('Error saving leave type:', error);
      showSnackbar(
        error.response?.data?.message || 'Failed to save leave type',
        'error'
      );
    }
  };
  
 const handleDeleteLeaveType = async () => {
  try {
    const response = await axiosInstance(localAxiosDelete(
      `/organization/deleteLeaveType/${currentLeaveType.id}`, 
      accessToken 
    ));
    
    if (response.data.status === 'SUCCESS') {
      showSnackbar(
        typeof response.data.message === 'string' 
          ? response.data.message 
          : 'Leave type deleted successfully',
        'success'
      );
      fetchLeaveTypes(); 
    } else {
      
      showSnackbar(
        typeof response.data.message === 'string'
          ? response.data.message
          : 'Failed to delete leave type',
        'error'
      );
    }
    handleCloseDeleteDialog(); 
  } catch (error) {
    console.error('Error deleting leave type:', error);
    showSnackbar(
      error.response?.data?.message || 'Failed to delete leave type. Please check your permissions.',
      'error'
    );
    
  }
};

  return (
    <Box sx={{ p: 3, backgroundColor: '#ffffff' }}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mb: 4
      }}>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Leave Types Management
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => handleOpenDialog()}
          sx={{ 
            borderRadius: 1,
            textTransform: 'none',
            px: 3
          }}
        >
          Add Leave Type
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
          <Table>
            <TableHead sx={{ bgcolor: theme.palette.primary.main }}>
              <TableRow>
                <TableCell sx={{ color: 'white', fontWeight: 600 }}>Name</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 600 }}>Description</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 600 }}>Max Days</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 600 }}>Status</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 600 }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leaveTypes.length > 0 ? (
                leaveTypes.map((leaveType) => (
                  <TableRow key={leaveType.id} hover>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box 
                          sx={{ 
                            width: 12, 
                            height: 12, 
                            borderRadius: '50%', 
                            bgcolor: leaveType.color,
                            mr: 1.5
                          }} 
                        />
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {leaveType.leave_type}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ maxWidth: 250 }}>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical'
                        }}
                      >
                        {leaveType.description}
                      </Typography>
                    </TableCell>
                    <TableCell>{leaveType.max_days}</TableCell>
                    <TableCell>
                      <Chip 
                        size="small" 
                        label={leaveType.is_active ? 'Active' : 'Inactive'} 
                        color={leaveType.is_active ? 'success' : 'default'}
                        sx={{ fontWeight: 500 }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton 
                        size="small" 
                        onClick={() => handleOpenDialog(leaveType)}
                        sx={{ mr: 1 }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton 
                        size="small" 
                        color="error"
                        onClick={() => handleOpenDeleteDialog(leaveType)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                    <Typography variant="body1" color="text.secondary">
                      No leave types found. Click "Add Leave Type" to create one.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
     
      <Dialog 
  open={dialogOpen} 
  onClose={handleCloseDialog}
  maxWidth="md"
  fullWidth
  PaperProps={{
    sx: {
      overflowY: 'visible' 
    }
  }}
>
  <DialogTitle sx={{ 
    bgcolor: theme.palette.primary.main, 
    color: 'white',
    py: 2
  }}>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography variant="h6">
        {editMode ? `Edit ${currentLeaveType.leave_type}` : 'Add New Leave Type'}
      </Typography>
      <IconButton 
        size="small" 
        onClick={handleCloseDialog}
        sx={{ color: 'white' }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  </DialogTitle>
  
 
  <Box sx={{ height: 16 }} />
  
  <DialogContent sx={{ 
    py: 4,    // Increased vertical padding
    px: 3,    // Consistent horizontal padding
  }}>
    <Grid container spacing={4}>  {/* Increased spacing between grid items */}
      <Grid item xs={12} md={6}>
        <TextField
          name="leave_type"
          label="Leave Type Name"
          value={currentLeaveType.leave_type}
          onChange={handleInputChange}
          fullWidth
          required
          variant="outlined"
          sx={{ mb: 1 }}  // Add margin bottom to each field
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          name="max_days"
          label="Maximum Days Per Year"
          type="number"
          value={currentLeaveType.max_days}
          onChange={handleNumberChange}
          fullWidth
          variant="outlined"
          sx={{ mb: 1 }}  // Add margin bottom to each field
          InputProps={{ inputProps: { min: 0, step: 0.5 } }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name="description"
          label="Description"
          value={currentLeaveType.description}
          onChange={handleInputChange}
          fullWidth
          multiline
          rows={3}  // Increased rows for better visibility
          variant="outlined"
          sx={{ mb: 1 }}  // Add margin bottom
        />
      </Grid>
      {editMode && (
        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Switch
                checked={currentLeaveType.is_active}
                onChange={handleSwitchChange}
                name="is_active"
                color="success"
              />
            }
            label="Active"
            sx={{ mt: 1 }}  // Add margin top to the switch
          />
        </Grid>
      )}
    </Grid>
  </DialogContent>
  
  {/* Spacer between content and actions */}
  <Box sx={{ height: 8 }} />
  
  <DialogActions sx={{ 
    px: 3, 
    py: 3,  // Increased padding
    borderTop: 1,  
    borderColor: 'divider'  
  }}>
    <Button 
      onClick={handleCloseDialog}
      variant="outlined"
      sx={{ 
        px: 3,  
        mr: 2   
      }}
    >
      Cancel
    </Button>
    <Button 
      onClick={handleSaveLeaveType} 
      variant="contained"
      sx={{ px: 3 }}  
    >
      {editMode ? 'Update' : 'Save'}
    </Button>
  </DialogActions>
</Dialog>
      
      <Dialog 
        open={deleteDialogOpen} 
        onClose={handleCloseDeleteDialog}
      >
        <DialogTitle sx={{ bgcolor: theme.palette.error.main, color: 'white' }}>
          Confirm Delete
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to delete the <strong>{currentLeaveType.leave_type}</strong> leave type?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This action cannot be undone and may affect existing leave records.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button 
            onClick={handleCloseDeleteDialog}
            variant="outlined"
          >
            Cancel
          </Button>
                   <Button 
            onClick={handleDeleteLeaveType} 
            variant="contained" 
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity} 
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default LeaveTypes;